import { useEffect } from "react";

function GoogleTagManager({ configCode, isDidomiReady }) {
  useEffect(() => {
    if (!isDidomiReady) return; // Wait for Didomi to be ready

    let gtmId = "GTM-5JFTM9M7"; // FR
    if (configCode === "onair.es") {
      gtmId = "GTM-P2XLMS4N"; // ES
    } else if (configCode === "onair.pt") {
      gtmId = "GTM-58RWHPNR"; // PT
    } else if (configCode === "onair.ma") {
      gtmId = "GTM-KB7HMM4R"; // MA
    }

    // Preprod (onair.integ) : bascule vers un conteneur GTM interne si fourni via
    // REACT_APP_GTM_INTEG (.env.preprod). Permet de valider la remontee en GA4
    // DebugView sur une propriete a nous, sans toucher aux 4 conteneurs de prod
    // et sans polluer le GA4 d'ON AIR. Absent en prod => comportement inchange.
    if (configCode === "onair.integ" && process.env.REACT_APP_GTM_INTEG) {
      gtmId = process.env.REACT_APP_GTM_INTEG;
    }

    // Initialisation de dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // Ajout du script GTM
    const script = document.createElement("script");
    script.async = true;

    // URL spécifique pour l'Espagne avec domaine personnalisé
    if (configCode === "onair.es") {
      const gtmIdWithoutPrefix = gtmId.replace(/^GTM-/, '');
      script.src = `https://metrics.onairfitness.es/go3ouwdgcnuudhs.js?awl=${gtmIdWithoutPrefix}&l=dataLayer`;
    } else {
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=dataLayer`;
    }

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    // Ajout du noscript GTM
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");

    // URL spécifique pour l'Espagne, URL standard pour les autres
    if (configCode === "onair.es") {
      iframe.src = `https://metrics.onairfitness.es/ns.html?id=${gtmId}`;
    } else {
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    }

    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    // Ajout d'une catégorie de page
    window.dataLayer.push({
      page_category: "Funnel",
    });
  }, [configCode, isDidomiReady]);

  return null; // Pas de rendu visuel
}

export default GoogleTagManager;
